import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>Hello internet.</p>
      </header>
    </div>
  );
}

export default App;
